import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import theme from 'theme/theme';
import { ArrowBackIcon, FilterFunnelIcon } from '../../components/Icon/index';
import MenuItem from './MenuItem'; // eslint-disable-line
import { toggleSubmenu, goBack } from '../../../store/ui/menu/actions';
import { getActiveDepth, isOpen } from '../../../store/ui/menu/selectors';
import ScrollBar from '../../components/ScrollBar';
import { Input } from '../../components/forms';

const SubMenuHeaderWrapper = styled.div`
  display: flex;
  align-items: center; 
  padding: 15px 15px 15px 25px;
  background: ${theme.colors.light};
  color: ${theme.colors.dark};
  font-size: ${theme.fontSizes.smallTitle};
  &:hover {
    cursor: pointer;
    svg {
      fill: ${theme.colors.white};
    }
  }
  @media (min-width: ${theme.breakpoints.desktop}) {
    min-height: 110px;
    padding-left: 30px;
  }
`;

const SubMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ItemList = styled.ul`
  margin: 0;
  padding: 0 0 0 0;
`;

const SubMenuWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background: ${theme.colors.light};
  font-size: ${theme.fontSizes.default};
  transition: 0.2s;
  transform: translateX(${(props) => (props.isActive ? '0%' : '100%')});
  
  @media (min-width: ${theme.breakpoints.desktop}) {
    ${(props) => props.depth === 0 && css`
      width: 110px;
      background: ${theme.colors.mediumLight};
      transform: translateX(0%);
      
      > div > div > div > div > div > ul > li > a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 110px;
      }
      > div > div > div > div > div > ul > li > a svg {
        display: block;
        margin: 0 auto 3px auto;
        width: 2.2em;
        height: 2.2em;
      }
    `}
    ${(props) => props.depth > 0 && css`
      width: 290px;
      transform: translateX(${props.isActive ? '0' : '100%'});
    `}
    ${(props) => props.depth === 1 && css`
      transform: translateX(${props.isActive ? '110px' : '400px'});
    `}
  }
`;

const FilterWrapper = styled.div`
  position: relative;
  height: 55px;
  color: ${theme.colors.medium};
  
  svg {
    position: absolute;
    left: 25px;
    top: 17px;
  }
  input {
    padding: 16px 15px 16px 50px;
    background: transparent;
    color: ${theme.colors.dark};
    &::placeholder {
      color: ${theme.colors.medium};
    }
  }
`;


class SubMenu extends React.Component {
  constructor(props) {
    super(props);
    this.filterInput = React.createRef();
    this.state = {
      filterValue: '',
    };
  }

  handleBackClick = () => {
    const {
      depth, activeDepth, goBack, toggle,
    } = this.props;

    if (activeDepth > depth) {
      if (activeDepth === 2) {
        toggle();
      }
      goBack(2);
    } else {
      if (activeDepth === 1) {
        toggle();
      }
      goBack();
    }
  };

  filterItems = (e) => {
    this.setState({ filterValue: e.target.value });
  };


  render() {
    const {
      name,
      items,
      hasFilter,
      filterLabel,
      depth,
      isActive,
      activeDepth,
      ...otherProps
    } = this.props;

    const { filterValue } = this.state;

    const filteredItems = hasFilter
      ? items.filter((item) => filterValue === ''
            || item.name.toLowerCase().includes(filterValue.toLowerCase()))
      : items;

    return (
      <SubMenuWrapper depth={depth} isActive={isActive} activeDepth={activeDepth} {...otherProps}>
        <ScrollBar heightRelativeToParent="100%">

          {depth > 0
            && (
            <SubMenuHeaderWrapper onClick={this.handleBackClick}>
              <SubMenuHeader>
                {name}
                <ArrowBackIcon />
              </SubMenuHeader>
            </SubMenuHeaderWrapper>
            )}

          {hasFilter && (
          <FilterWrapper>
            <FilterFunnelIcon />
            <Input
              ref={this.filterInput}
              onChange={this.filterItems}
              placeholder={filterLabel}
              variant="ghost"
            />
          </FilterWrapper>

          )}

          <ItemList>
            {filteredItems.map((item) => (
              <MenuItem
                key={item.key}
                item={item}
                depth={depth}
                {...otherProps}
                {...item.props}
              />
            ))}
          </ItemList>

        </ScrollBar>
      </SubMenuWrapper>
    );
  }
}

SubMenu.propTypes = {
  name: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  depth: PropTypes.number,
  isActive: PropTypes.bool,
  activeDepth: PropTypes.number.isRequired,
  goBack: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  hasFilter: PropTypes.bool,
  filterLabel: PropTypes.string,
};

SubMenu.defaultProps = {
  name: '',
  depth: 0,
  isActive: false,
  hasFilter: false,
  filterLabel: 'Filter items...',
};

const mapStateToProps = (state) => ({
  activeDepth: getActiveDepth(state),
  isOpen: isOpen(state),
});

const mapDispatchToProps = {
  toggle: toggleSubmenu,
  goBack,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubMenu);
